// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KqNF8UbWOoS9qrP_Nx58 .ant-spin .ant-spin-dot-item{background-color:#c0d6e2 !important}`, "",{"version":3,"sources":["webpack://./modules/SitPanel/components/Map/Map.module.scss"],"names":[],"mappings":"AAKM,mDACE,mCAAA","sourcesContent":["@import \"src/assets/scss/variables\";\r\n\r\n.spinnerMap {\r\n  :global {\r\n    .ant-spin {\r\n      .ant-spin-dot-item {\r\n        background-color: $tab-color !important;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerMap": `KqNF8UbWOoS9qrP_Nx58`
};
export default ___CSS_LOADER_EXPORT___;
